// extracted by mini-css-extract-plugin
export default {"creditTabWrapper":"Dms7X","image":"SwU51","iconImg":"j17Kr","iconWrapper":"sLbWI","priceContainer":"pHqU8","price":"kbFV_"};